var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "USDT 40px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo&buttom-svg",
    transform: "translate(-494.000000, -818.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "USDT-40px",
    transform: "translate(494.000000, 818.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4013445,24.8380791 C36.7300499,35.5523033 25.8769198,42.0729645 15.1600713,39.4013001 C4.44772335,36.729969 -2.07357578,25.8774448 0.599035609,15.1639206 C3.2693034,4.44836298 14.1224236,-2.07267483 24.8359716,0.598469574 C35.55192,3.26961065 42.0729724,14.1233881 39.4013445,24.838279 L39.4013445,24.8380791 L39.4013445,24.8380791 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#50AF95",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5332844,22.2673812 C22.3918355,22.2779812 21.6610882,22.3215812 20.0310751,22.3215812 C18.7345988,22.3215812 17.8140973,22.2827145 17.4911617,22.2673812 C12.4808759,22.0470147 8.74113014,21.1749155 8.74113014,20.130783 C8.74113014,19.0866506 12.4808759,18.2157513 17.4911617,17.9918515 L17.4911617,21.3988486 C17.8188312,21.4224153 18.7570013,21.4778152 20.0534776,21.4778152 C21.6092492,21.4778152 22.3883017,21.412982 22.5285505,21.4000153 L22.5285505,17.9942182 C27.5282352,18.2169513 31.2597467,19.0890173 31.2597467,20.130783 C31.2597467,21.1725822 27.5294353,22.0446481 22.5285505,22.2662146 L22.5332844,22.2673812 Z M22.5332844,17.6418518 L22.5332844,14.5930877 L29.5106871,14.5930877 L29.5106871,9.94399166 L10.5137589,9.94399166 L10.5137589,14.5930877 L17.4899949,14.5930877 L17.4899949,17.6406518 C11.8196696,17.9011183 7.55543272,19.024184 7.55543272,20.3700162 C7.55543272,21.7158484 11.8196696,22.8377807 17.4899949,23.0993805 L17.4899949,32.8690056 L22.5320842,32.8690056 L22.5320842,23.0958472 C28.1894414,22.8354141 32.4466109,21.7134817 32.4466109,20.3688495 C32.4466109,19.024184 28.1929752,17.9022849 22.5320842,17.6406518 L22.5332844,17.6418518 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.86bfaccb49d9d4449785bcf94efba043.svg";
export { ForwardRef as ReactComponent };